import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-bar-icon',
    templateUrl: './bar-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BarIconComponent {}
